import {ResearchLitElement, html, css} from '@core/research-lit-element';

import '@bog-design-system/bd-font';
import '@bog-design-system/bd-button';
import '@bog-design-system/bd-footer-bottom';

import '../layout/research-section';

class ResearchFooter extends ResearchLitElement {
    static get is() {
        return 'research-footer';
    }

    static get styles() {
        return css``;
    }

    render() {
        return html`
            <research-section no-pad-bottom no-pad-top>
                <bd-footer-bottom has-links has-icons>
                    <div slot="license">${this.data?.copyright}</div>

                    <bd-footer-bottom-links slot="quick-links">
                        ${this.data?.links?.length > 0 ? this.data.links.map(
                            (link) => html`
                                <bd-footer-bottom-link href="${link?.url?.link}">
                                    <bd-font type="small-text">${link?.label}</bd-font>
                                </bd-footer-bottom-link>
                            `
                        ) : ''}
                    </bd-footer-bottom-links>

                    <bd-footer-bottom-icons slot="icons">
                        <bd-button
                            icon-only
                            mini
                            type="secondary"
                            icon="bd:social_facebook"
                            href="https://www.facebook.com/BankOfGeorgia/"
                            dropdownicon="bd:chevron_down"
                        >
                        </bd-button>
                        <bd-button
                            icon-only
                            mini
                            type="secondary"
                            icon="bd:social_youtube"
                            href="https://www.youtube.com/user/BankofGeorgiaTV"
                            dropdownicon="bd:chevron_down"
                        >
                        </bd-button>
                        <bd-button
                            icon-only
                            mini
                            type="secondary"
                            icon="bd:social_instagram"
                            href="https://www.instagram.com/bankofgeorgia/"
                            dropdownicon="bd:chevron_down"
                        >
                        </bd-button>
                        <bd-button
                            icon-only
                            mini
                            type="secondary"
                            icon="bd:social_linkedin"
                            href="https://www.linkedin.com/company/bank-of-georgia"
                            dropdownicon="bd:chevron_down"
                        >
                        </bd-button>
                    </bd-footer-bottom-icons>
                </bd-footer-bottom>
            </research-section>
        `;
    }

    constructor() {
        super();

        this.year = new Date().getFullYear();
    }

    static get properties() {
        return {
            data: {
                type: Object,
            },
        };
    }

    connectedCallback() {
        super.connectedCallback();
        this.apiCall(`common/application-data?contentType=App.Common.footer`).then((res) => {
            this.data = res.json.data;

            this.data.copyright = this.data?.copyright?.replace('[[year]]', this.year);
        });
    }
}

window.customElements.define(ResearchFooter.is, ResearchFooter);
